<template>
  <div class="account-page">
    <div class="main-wrapper">
      <div class="account-content">
        <div class="login-wrapper">
          <div class="login-img">
            <img src="../../../assets/img/login.png" alt="img" />
          </div>
          <div class="login-content">
            <div class="login-userset">
              <div class="login-logo logo-normal">
                <img src="../../../assets/img/logo.png" alt="img" />
              </div>
              <router-link to="/index" class="login-logo logo-white">
                <img src="../../../assets/img/logo-white.png" alt="" />
              </router-link>
              <div class="login-userheading">
                <h3>Enter a new PIN</h3>
                <h4>Please enter your new pin</h4>
              </div>
              <form class="login" @submit.prevent="onSubmit">
                <div class="form-login">
                  <label>Pin</label>
                  <div class="form-addons">
                    <div class="d-flex gap-2">
                      <div v-for="(field, index) in pinFields" :key="index">
                        <input
                          v-model="pinFields[index]"
                          @input="handleInput(index)"
                          @keydown="handleKeyDown(index, $event)"
                          :maxlength="1"
                          :autofocus="index === 0"
                          type="text"
                          :ref="'pinField' + index"
                          ref-in-for
                          :id="'pin' + (index + 1)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-login">
                  <button class="btn btn-login" type="submit" ref="buttonSignin">Save</button>
                </div>
              </form>
              <div class="signinform text-center d-flex justify-content-between">
                <router-link to="/" class="hover-a">Change account</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { goPage } from "@/assets/js/function";

export default {
  data() {
    return {
      pinFields: ['', '', '', '']
    };
  },
  methods: {
    handleInput(index) {
      this.pinFields[index] = this.pinFields[index].replace(/[^0-9]/g, '');
      if (this.pinFields[index].length === 1 && index < 3) {
        this.$refs['pinField' + (index + 1)][0].focus();
      }
      if (index === 3) {
        this.onSubmit(); // ✅ lebih aman daripada klik button
      }
    },
    handleKeyDown(index, event) {
      if (event.key.match(/[^0-9]/) && event.key !== 'Backspace') {
        event.preventDefault();
      } else if (event.key === 'Backspace' && index > 0 && this.pinFields[index] === '') {
        this.$refs['pinField' + (index - 1)][0].focus();
      }
    },
    onSubmit() {
      const pinFinal = this.pinFields.join('');
      if (pinFinal.length !== 4) return alert("PIN must be 4 digits");
      localStorage.setItem('pin-confirm', pinFinal);
      goPage('confirm-pin');
    }
  },
  created() {
    if (!Cookies.get('token_refresh')) {
      goPage('/');
    }
  }
};
</script>
